// 商城搜索项 列表商城字段 字典
const basics = {
    platform_obj: {
      "taobao": "淘宝",
      "jingdong": "京东",
      "tianmao": "天猫",
      "kaola": "考拉",
      "suning": "苏宁",
      "douyin": "抖音小店",
      "pinduoduo": "拼多多",
      "淘宝": "淘宝",
      "京东": "京东",
      "天猫": "天猫",
      "考拉": "考拉",
      "苏宁": "苏宁",
      "抖音小店": "抖音小店",
      "拼多多": "拼多多",
    },
    select_platform_arr: [
      { value: "taobao", label: "淘宝" },
      { value: "jingdong", label: "京东" },
      { value: "tianmao", label: "天猫" },
      { value: "kaola", label: "考拉" },
      { value: "suning", label: "苏宁" },
      { value: "douyin", label: "抖音小店" },
      { value: "pinduoduo", label: "拼多多" },
    ],
    //  
    talent_obj:{
      "1":"抖音",
      "2":"快手",
      "3":"哔哩哔哩",
      "4":" 微博",
      "5":"公众号",
      "6":"淘宝直播",
      "7":"西瓜视频"
    },
  }
  
  export default basics;